export default __webpack_public_path__ + "static/media/catz_small.09c0e5a2.png";